module.exports = __webpack_public_path__ + "img/nvzhanshi.63f15c6c.png";